import * as React from 'react';

const SvgGps = (props) => (
  <svg
    width={42}
    height={42}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#gps_svg__a)'>
      <path
        d='M26.25 39.813h-10.5c-7.717 0-10.063-2.346-10.063-10.063v-17.5c0-7.718 2.346-10.063 10.063-10.063h10.5c7.718 0 10.063 2.345 10.063 10.063v17.5c0 7.718-2.346 10.063-10.063 10.063Zm-10.5-35c-6.265 0-7.438 1.19-7.438 7.437v17.5c0 6.248 1.173 7.438 7.438 7.438h10.5c6.265 0 7.438-1.19 7.438-7.438v-17.5c0-6.247-1.173-7.438-7.438-7.438h-10.5Z'
        fill='#858585'
      />
      <path
        d='M24.261 10.938H15.99c-.848 0-1.552-.596-1.552-1.313s.704-1.313 1.552-1.313h8.272c.848 0 1.552.596 1.552 1.313s-.704 1.313-1.552 1.313ZM21 34.755a4.026 4.026 0 1 1 .001-8.051 4.026 4.026 0 0 1 0 8.051Zm0-5.442c-.77 0-1.4.63-1.4 1.4 0 .77.63 1.4 1.4 1.4.77 0 1.4-.63 1.4-1.4 0-.77-.63-1.4-1.4-1.4Z'
        fill='#858585'
      />
      <path
        d='M31.5 1.75c-4.883 0-8.75 4.289-8.75 9.46 0 1.659.815 3.612 1.84 5.445 1.043 1.862 2.373 3.721 3.539 5.225l.039.05c.57.734 1.054 1.359 1.524 1.79.513.472 1.079.78 1.808.78.73 0 1.295-.308 1.808-.78.47-.431.955-1.056 1.524-1.79l.039-.05c1.166-1.504 2.496-3.363 3.538-5.225 1.026-1.833 1.841-3.786 1.841-5.445 0-5.171-3.867-9.46-8.75-9.46Z'
        fill='#E9E9E9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.25 11.21c0-6.815 5.157-12.96 12.25-12.96s12.25 6.145 12.25 12.96c0 2.615-1.215 5.24-2.286 7.154-1.162 2.077-2.61 4.09-3.828 5.661m0 0-.038.05-.089.114c-.493.637-1.14 1.472-1.834 2.11l-2.367-2.578c.47-.432.955-1.057 1.524-1.791l.039-.05c1.166-1.504 2.496-3.363 3.538-5.225 1.026-1.833 1.841-3.786 1.841-5.445 0-5.171-3.867-9.46-8.75-9.46s-8.75 4.289-8.75 9.46c0 1.659.815 3.612 1.84 5.445 1.043 1.862 2.373 3.721 3.539 5.225l.039.05c.57.734 1.054 1.359 1.524 1.79L27.325 26.3c-.694-.638-1.341-1.473-1.834-2.11l-.089-.114m0 0-.038-.05c-1.219-1.57-2.666-3.584-3.828-5.661-1.07-1.914-2.286-4.54-2.286-7.154m10.442 12.51c.513.472 1.079.78 1.808.78.73 0 1.295-.308 1.808-.78l2.367 2.579C34.748 27.15 33.376 28 31.5 28s-3.248-.85-4.175-1.701l2.367-2.578Z'
        fill='#E9E9E9'
      />
      <path fill='#E9E9E9' d='M33.25 21h3.5v3.5h-3.5z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.5 3.063c-4.055 0-7.438 3.592-7.438 8.147 0 1.3.665 3.001 1.674 4.804.997 1.782 2.284 3.583 3.43 5.061l.039.05c.594.766 1.005 1.289 1.375 1.629.358.328.621.433.92.433.299 0 .562-.105.92-.433.37-.34.781-.863 1.375-1.629l.039-.05c1.146-1.478 2.433-3.28 3.43-5.061 1.008-1.803 1.673-3.503 1.673-4.804 0-4.555-3.383-8.148-7.437-8.148ZM21.437 11.21C21.438 5.422 25.788.437 31.5.437c5.712 0 10.063 4.985 10.063 10.773 0 2.017-.966 4.222-2.008 6.086-1.087 1.942-2.461 3.86-3.647 5.388m0 0-.039.05-.049.064c-.529.682-1.072 1.382-1.624 1.89-.669.613-1.537 1.125-2.696 1.125-1.16 0-2.027-.512-2.695-1.126-.553-.507-1.096-1.207-1.625-1.89l-.05-.063-.038-.05c-1.186-1.528-2.56-3.446-3.647-5.388-1.042-1.864-2.008-4.069-2.008-6.086'
        fill='#858585'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.5 8.313a2.188 2.188 0 1 0 0 4.375 2.188 2.188 0 0 0 0-4.376ZM26.687 10.5a4.812 4.812 0 1 1 9.625 0 4.812 4.812 0 0 1-9.624 0Z'
        fill='#858585'
      />
    </g>
    <defs>
      <clipPath id='gps_svg__a'>
        <path fill='#fff' d='M0 0h42v42H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgGps;
